export default __webpack_public_path__ + "Muli-SemiBold.ttf";